@let formGroupDelivery = userService.formGroupDelivery;
@let deliveryTargetsValue = deliveryTargets();
<form [formGroup]="formGroupDelivery">
  @let userServiceUserDataValue = userService.userData();
  @let egpTypesValue = egpTypes();
  @let areAllProductsSelectedValue = userService.areAllProductsSelected();
  @if (formGroupDelivery | isNil: false) {
    <mat-card appearance="outlined">
      <div class="form-column-left">
        <fa-icon
          [icon]="['far', 'paper-plane']"
          size="4x"
          style="color: grey"></fa-icon>
      </div>
      <div class="form-column-right">
        <p>{{ 'PRODUCT.USERADMIN.DELIVERY.INFO' | translate }}</p>
        <mat-checkbox
          formControlName="active"
          (change)="onDeliverySetActive($event)"
          #delivery
          >{{ 'PRODUCT.USERADMIN.DELIVERY.ACTIVE' | translate }}</mat-checkbox
        >
        <br />
        @if (isDeliveryActive()) {
          <p>
            <b>{{ 'PRODUCT.USERADMIN.DELIVERY.CALLTOACTION' | translate }}</b>
          </p>
          <mat-form-field>
            <mat-label>{{
              'PRODUCT.USERADMIN.DELIVERY.DATEFROM' | translate
            }}</mat-label>
            <input
              matInput
              [matDatepicker]="picker8"
              formControlName="dateFrom" />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker8"></mat-datepicker-toggle>
            <mat-datepicker #picker8></mat-datepicker>
          </mat-form-field>
          &nbsp;
          <mat-checkbox formControlName="endless" #deliveryEndless>{{
            'PRODUCT.USERADMIN.DELIVERY.ENDLESS' | translate
          }}</mat-checkbox>
          @if (!deliveryEndless.checked) {
            <br />
            <mat-form-field>
              <mat-label>{{
                'PRODUCT.USERADMIN.DELIVERY.DATETO' | translate
              }}</mat-label>
              <input
                matInput
                [matDatepicker]="picker9"
                formControlName="dateTo" />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker9"></mat-datepicker-toggle>
              <mat-datepicker #picker9></mat-datepicker>
            </mat-form-field>
            @if (dateToFormControlErrors() | isNil: false) {
              <div class="error-text">
                {{ 'PRODUCT.USERADMIN.STAMMDATEN.DATEERROR' | translate }}
              </div>
            }
          }
        }
      </div>
      <div class="clear"></div>
    </mat-card>
  }

  @let activeFormControlValueSignal = activeFormControlValue();
  @if (activeFormControlValueSignal) {
    <mat-card appearance="outlined">
      <p>
        <b
          >{{ 'PRODUCT.USERADMIN.DELIVERY.TARGETSFOR' | translate }}
          {{ nameFormControlValue() }}</b
        ><br />
        <span style="color: #333333">{{
          'PRODUCT.USERADMIN.DELIVERY.INPUTTARGETS' | translate
        }}</span>
      </p>

      <table>
        @let userServiceUsedContingentsValue = userService.usedContingents();
        @let contingentsValue = contingents();
        @for (targetType of ['email', 'sms', 'fax']; track $index) {
          <tr>
            <td>
              <fa-icon
                [icon]="deliveryTargetIcons()[targetType]"
                size="2x"
                style="color: #333333"></fa-icon>
            </td>
            <td style="white-space: nowrap">
              {{ 'SETTINGS.SENDMAN.TYPE.' + targetType | translate }}
            </td>
            <td>
              @if (targetType !== 'email') {
                <span
                  matTooltip="{{
                    'PRODUCT.USERADMIN.CONTINGENT.TEXT1' | translate
                  }} {{
                    'PRODUCT.USERADMIN.CONTINGENT.' + targetType + '_SHORT'
                      | translate
                  }}: {{ contingentsValue[targetType] }}. {{
                    'PRODUCT.USERADMIN.CONTINGENT.TEXT2' | translate
                  }}: {{ userServiceUsedContingentsValue[targetType] }}">
                  <fa-icon
                    [icon]="['far', 'asterisk']"
                    [ngStyle]="{
                      color:
                        userServiceUsedContingentsValue[targetType] <
                        contingentsValue[targetType]
                          ? 'green'
                          : 'red',
                    }"></fa-icon>
                </span>
              }
            </td>
            <td>
              <mat-chip-grid #chipList aria-label="Adressen">
                @let emailFormControlValueSignal = emailFormControlValue();
                @for (
                  address of deliveryTargetsValue[targetType];
                  track $index
                ) {
                  <mat-chip-row
                    [removable]="address !== emailFormControlValueSignal"
                    color="primary"
                    (removed)="onRemove({ targetType, address })">
                    @if (targetType === 'email') {
                      <span>{{ address }}</span>
                    } @else {
                      <span>{{ address | phonenumber }}</span>
                    }

                    @if (address !== emailFormControlValueSignal) {
                      <mat-icon matChipRemove>cancel </mat-icon>
                    }
                  </mat-chip-row>
                }
                <mat-form-field>
                  @let deliveryTargetControl =
                    userService.deliveryTargetControl;
                  <input
                    matInput
                    placeholder="{{
                      ((deliveryTargetControl[targetType].errors | isNil)
                        ? 'PRODUCT.USERADMIN.DELIVERY.NEWTARGET'
                        : 'PRODUCT.USERADMIN.DELIVERY.WRONGTARGETFORMAT'
                      ) | translate
                    }}"
                    [disabled]="
                      targetType !== 'email' &&
                      userServiceUsedContingentsValue[targetType] >=
                        contingentsValue[targetType]
                    "
                    [formControl]="deliveryTargetControl[targetType]"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes()"
                    [matChipInputAddOnBlur]="true"
                    (matChipInputTokenEnd)="
                      onAdd({ targetType, event: $event })
                    " />
                </mat-form-field>
                @if (
                  targetType !== 'email' &&
                  userServiceUsedContingentsValue[targetType] >=
                    contingentsValue[targetType]
                ) {
                  <span style="color: #aeaeae">
                    ({{ 'PRODUCT.USERADMIN.CONTINGENT.FULL' | translate }})
                  </span>
                }
                <br />
                @if (targetType !== 'email') {
                  <span style="color: #aeaeae">
                    {{ 'PRODUCT.USERADMIN.CONTINGENT.USED' | translate }}:
                    {{ userServiceUsedContingentsValue[targetType] }} /
                    {{ contingentsValue[targetType] }}
                  </span>
                }
              </mat-chip-grid>
            </td>
          </tr>
        }
      </table>
    </mat-card>
  }

  @if (activeFormControlValueSignal) {
    <mat-card appearance="outlined">
      <p>
        <b>{{ 'PRODUCT.USERADMIN.PRODUCTS.TITLE' | translate }}</b>
      </p>
      <ng-container
        *ngTemplateOutlet="
          buttonsTemplate();
          context: { section: 'delivery' }
        "></ng-container>

      <mat-list>
        @let productListValue = productList();
        @if (productListValue.epp | isNotEmptyObject) {
          <!--epp-->
          <div mat-subheader>
            <fa-icon [icon]="['far', 'clouds-sun']" size="lg"></fa-icon>
            &nbsp; {{ 'PRODUCT.EPP.TITLE' | translate }} NEU
          </div>

          <mat-accordion
            #accordionEppDelivery="matAccordion"
            multi
            class="accordion-headers-align">
            @for (
              parameterset of userService.eppParametersets();
              track $index
            ) {
              @for (resolution of userService.eppResolutions(); track $index) {
                <mat-expansion-panel
                  (expandedChange)="onExpandedChanged('delivery')">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      @let hasUserEppProduct =
                        'delivery'
                          | hasUserEppProduct
                            : areAllProductsSelectedValue
                            : userServiceUserDataValue
                            : productListValue
                            : parameterset
                            : resolution;
                      @if (hasUserEppProduct) {
                        <span>
                          <ng-container
                            *ngTemplateOutlet="greenCheckIcon"></ng-container>
                        </span>
                      } @else {
                        <span>
                          <ng-container
                            *ngTemplateOutlet="redTimesIcon"></ng-container>
                        </span>
                      }
                      &nbsp;{{
                        'PRODUCT.EPP.PARAMETERSET.SETS.' + parameterset
                          | translate
                      }}
                      - {{ resolution.days }}
                      {{ 'PRODUCT.EPP.RESOLUTION.DAYS' | translate }} ({{
                        'PRODUCT.EPP.RESOLUTION.HOURLY.' + resolution.hourly
                          | translate
                      }})
                    </mat-panel-title>
                    <mat-panel-description>
                      {{
                        'delivery'
                          | countUserProductStations
                            : areAllProductsSelectedValue
                            : 'epp'
                            : {
                                eppParameterset: parameterset,
                                eppResolution: resolution,
                              }
                            : productListValue
                            : userServiceUserDataValue
                      }}
                      /
                      {{
                        productListValue.epp[parameterset][
                          resolution.days + '_' + resolution.hourly
                        ].length
                      }}
                      {{ 'PRODUCT.USERADMIN.PLACES' | translate }}
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <table class="product-detail-table" width="100%">
                    <tr>
                      <th>
                        {{ 'PRODUCT.USERADMIN.DELIVERY.TITLE' | translate }}
                      </th>
                      <th>
                        {{ 'PRODUCT.USERADMIN.DELIVERY.TO' | translate }}
                      </th>
                      <th>{{ 'PRODUCT.USERADMIN.PLACE' | translate }}</th>
                      <th>
                        {{ 'PRODUCT.USERADMIN.DELIVERY.DEADLINES' | translate }}
                      </th>
                      <th>
                        {{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}
                      </th>
                      <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                    </tr>
                    @for (
                      product of productListValue.epp[parameterset][
                        resolution.days + '_' + resolution.hourly
                      ];
                      track $index;
                      let i = $index
                    ) {
                      <tr>
                        <td align="center">
                          <mat-checkbox
                            #check
                            [checked]="
                              userServiceUserDataValue
                                | hasUserStation
                                  : product
                                  : 'delivery'
                                  : areAllProductsSelectedValue
                            "
                            (change)="
                              onDeliveryChange(
                                $event,
                                product,
                                product['formControlName']
                              )
                            "></mat-checkbox>
                        </td>
                        <td>
                          @if (
                            check.checked &&
                            (userServiceUserDataValue
                              | hasUserStation
                                : product
                                : 'delivery'
                                : areAllProductsSelectedValue)
                          ) {
                            <ng-container
                              *ngTemplateOutlet="
                                deliverTargets;
                                context: {
                                  isEmail: true,
                                  isSms: false,
                                  isFax: true,
                                  product: product,
                                }
                              "></ng-container>
                          }
                        </td>
                        <td>
                          {{ product['station']['overwriteStationName'] }}
                        </td>
                        <td>
                          @for (
                            deadline of product['productData']['deadlines'];
                            track $index
                          ) {
                            <span>{{ deadline }}<br /></span>
                          }
                        </td>
                        <td>
                          <ng-container
                            *ngTemplateOutlet="
                              productOutOfSeason;
                              context: { $implicit: product }
                            "></ng-container>
                        </td>
                        <td>
                          <ng-container
                            *ngTemplateOutlet="
                              productDates;
                              context: { $implicit: product }
                            "></ng-container>
                        </td>
                      </tr>
                    }
                  </table>
                </mat-expansion-panel>
              }
            }
          </mat-accordion>
        }

        @if (isMaster() && productListValue.eop | isNotEmptyObject) {
          <!--eop-->

          <div mat-subheader>
            <fa-icon [icon]="['far', 'table']" size="lg"></fa-icon>
            &nbsp; {{ 'PRODUCT.EOP.TITLE' | translate }} ALT
          </div>

          <mat-accordion
            #accordionEopDelivery="matAccordion"
            multi
            class="accordion-headers-align">
            @for (eopType of eopTypesWithDelivery(); track $index) {
              @if (productListValue.eop.hasOwnProperty(eopType)) {
                <mat-expansion-panel
                  (expandedChange)="onExpandedChanged('delivery')">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      @let hasUserEopProduct =
                        'delivery'
                          | hasUserEopProduct
                            : areAllProductsSelectedValue
                            : userServiceUserDataValue
                            : productListValue
                            : eopType;
                      @if (hasUserEopProduct) {
                        <span>
                          <ng-container
                            *ngTemplateOutlet="greenCheckIcon"></ng-container>
                        </span>
                      } @else {
                        <span>
                          <ng-container
                            *ngTemplateOutlet="redTimesIcon"></ng-container>
                        </span>
                      }
                      &nbsp;{{ 'PRODUCT.EOP.TYPE.' + eopType | translate }}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{
                        'delivery'
                          | countUserProductStations
                            : areAllProductsSelectedValue
                            : 'eop'
                            : {
                                productType: eopType,
                              }
                            : productListValue
                            : userServiceUserDataValue
                      }}
                      / {{ productListValue.eop[eopType].length }}
                      {{ 'PRODUCT.USERADMIN.PLACES' | translate }}
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <table class="product-detail-table" width="100%">
                    <tr>
                      <th>
                        {{ 'PRODUCT.USERADMIN.DELIVERY.TITLE' | translate }}
                      </th>
                      <th>
                        {{ 'PRODUCT.USERADMIN.DELIVERY.TO' | translate }}
                      </th>
                      <th>{{ 'PRODUCT.USERADMIN.PLACE' | translate }}</th>
                      <th>
                        {{ 'PRODUCT.USERADMIN.DELIVERY.DEADLINES' | translate }}
                      </th>
                      <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                      <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                    </tr>
                    @for (
                      product of productListValue.eop[eopType];
                      track $index;
                      let i = $index
                    ) {
                      <tr>
                        <td align="center">
                          <mat-checkbox
                            #check
                            [checked]="
                              userServiceUserDataValue
                                | hasUserStation
                                  : product
                                  : 'delivery'
                                  : areAllProductsSelectedValue
                            "
                            (change)="
                              onDeliveryChange(
                                $event,
                                product,
                                product['formControlName']
                              )
                            "></mat-checkbox>
                        </td>
                        <td>
                          @if (
                            check.checked &&
                            (userServiceUserDataValue
                              | hasUserStation
                                : product
                                : 'delivery'
                                : areAllProductsSelectedValue)
                          ) {
                            <ng-container
                              *ngTemplateOutlet="
                                deliverTargets;
                                context: {
                                  isEmail: true,
                                  isSms: false,
                                  isFax: true,
                                  product: product,
                                }
                              "></ng-container>
                          }
                        </td>
                        <td>
                          {{ product['station']['overwriteStationName'] }}
                        </td>
                        <td>
                          @for (
                            deadline of product['productData']['deadlines'];
                            track $index
                          ) {
                            <span>{{ deadline }}<br /></span>
                          }
                        </td>
                        <td>
                          <ng-container
                            *ngTemplateOutlet="
                              productOutOfSeason;
                              context: { $implicit: product }
                            "></ng-container>
                        </td>
                        <td>
                          <ng-container
                            *ngTemplateOutlet="
                              productDates;
                              context: { $implicit: product }
                            "></ng-container>
                        </td>
                      </tr>
                    }
                  </table>
                </mat-expansion-panel>
              }
            }
          </mat-accordion>
        }
        @if (
          productListValue.egp.length + productListValue.egpsummer.length > 0
        ) {
          <!--egp-->
          <div mat-subheader>
            <i class="far fa-pen fa-lg"></i> &nbsp;
            {{ 'PRODUCT.EGP.TITLE' | translate }}
          </div>
        }

        <mat-accordion
          #accordionEgpDelivery="matAccordion"
          multi
          class="accordion-headers-align">
          @for (productType of ['egp', 'egpsummer']; track $index) {
            @if (productListValue[productType].length > 0) {
              <mat-expansion-panel
                (expandedChange)="onExpandedChanged('delivery')">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    @if (
                      'delivery'
                        | hasUserProductType
                          : productType
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    ) {
                      <span>
                        <ng-container
                          *ngTemplateOutlet="greenCheckIcon"></ng-container>
                      </span>
                    } @else {
                      <span>
                        <ng-container
                          *ngTemplateOutlet="redTimesIcon"></ng-container>
                      </span>
                    }
                    &nbsp;
                    {{ 'SAISON.' + egpTypesValue[productType] | translate }}
                  </mat-panel-title>
                  <mat-panel-description>
                    {{
                      'delivery'
                        | countUserProducts
                          : productType
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    }}
                    /
                    {{ productListValue[productType].length }}
                    {{ 'PRODUCT.USERADMIN.REGIONS' | translate }}
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <table class="product-detail-table" width="100%">
                  <tr>
                    <th>
                      {{ 'PRODUCT.USERADMIN.DELIVERY.TITLE' | translate }}
                    </th>
                    <th>{{ 'PRODUCT.USERADMIN.DELIVERY.TO' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.REGION' | translate }}</th>
                    <th>
                      {{ 'PRODUCT.USERADMIN.DELIVERY.DEADLINES' | translate }}
                    </th>
                    <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                  </tr>
                  @for (
                    product of productListValue[productType];
                    track $index;
                    let i = $index
                  ) {
                    <tr>
                      <td align="center">
                        <mat-checkbox
                          #check
                          [checked]="
                            'delivery'
                              | hasUserProduct
                                : areAllProductsSelectedValue
                                : userServiceUserDataValue
                                : product['id']
                          "
                          (change)="
                            onDeliveryChange(
                              $event,
                              product,
                              product['formControlName']
                            )
                          "></mat-checkbox>
                      </td>
                      <td>
                        @if (
                          check.checked &&
                          ('delivery'
                            | hasUserProduct
                              : areAllProductsSelectedValue
                              : userServiceUserDataValue
                              : product['id'])
                        ) {
                          <ng-container
                            *ngTemplateOutlet="
                              deliverTargets;
                              context: {
                                isEmail: true,
                                isSms: false,
                                isFax: true,
                                product: product,
                              }
                            "></ng-container>
                        }
                      </td>

                      <td>{{ product['area'] }}</td>
                      <td>
                        @for (
                          deadline of product['productData']['deadlines'];
                          track $index
                        ) {
                          <span>{{ deadline }}<br /></span>
                        }
                      </td>
                      <td>
                        <ng-container
                          *ngTemplateOutlet="
                            productOutOfSeason;
                            context: { $implicit: product }
                          "></ng-container>
                      </td>
                      <td>
                        <ng-container
                          *ngTemplateOutlet="
                            productDates;
                            context: { $implicit: product }
                          "></ng-container>
                      </td>
                    </tr>
                  }
                </table>
              </mat-expansion-panel>
            }
          }
        </mat-accordion>
        @if (
          productListValue.egw.length + productListValue.egwsummer.length > 0
        ) {
          <!--egw summer-->
          <div mat-subheader>
            <fa-icon
              [icon]="['far', 'exclamation-triangle']"
              size="lg"></fa-icon>
            &nbsp; {{ 'PRODUCT.WARNING.TITLE' | translate }}
          </div>
        }
        <mat-accordion
          #accordionEgwDelivery="matAccordion"
          multi
          class="accordion-headers-align">
          @for (productType of ['egw']; track $index) {
            @if (productListValue[productType].length > 0) {
              <mat-expansion-panel
                (expandedChange)="onExpandedChanged('delivery')">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    @if (
                      'delivery'
                        | hasUserProductType
                          : productType
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    ) {
                      <span>
                        <ng-container
                          *ngTemplateOutlet="greenCheckIcon"></ng-container>
                      </span>
                    } @else {
                      <span>
                        <ng-container
                          *ngTemplateOutlet="redTimesIcon"></ng-container>
                      </span>
                    }
                    &nbsp;
                    {{ 'SAISON.' + egpTypesValue[productType] | translate }}
                  </mat-panel-title>
                  <mat-panel-description>
                    {{
                      'delivery'
                        | countUserProducts
                          : 'egw'
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    }}
                    /
                    {{ productListValue.egw.length }}
                    {{ 'PRODUCT.USERADMIN.REGIONS' | translate }}
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <table class="product-detail-table" width="100%">
                  <tr>
                    <th align="center">
                      {{ 'PRODUCT.USERADMIN.DELIVERY.TITLE' | translate }}
                    </th>
                    <th>{{ 'PRODUCT.USERADMIN.DELIVERY.TO' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.REGION' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                  </tr>
                  @for (
                    product of productListValue.egw;
                    track $index;
                    let i = $index
                  ) {
                    <tr>
                      <td align="center">
                        <mat-checkbox
                          #check
                          [checked]="
                            'delivery'
                              | hasUserProduct
                                : areAllProductsSelectedValue
                                : userServiceUserDataValue
                                : product['id']
                          "
                          (change)="
                            onDeliveryChange(
                              $event,
                              product,
                              product['formControlName']
                            )
                          "></mat-checkbox>
                      </td>
                      <td>
                        @if (
                          check.checked &&
                          ('delivery'
                            | hasUserProduct
                              : areAllProductsSelectedValue
                              : userServiceUserDataValue
                              : product['id'])
                        ) {
                          <ng-container
                            *ngTemplateOutlet="
                              deliverTargets;
                              context: {
                                isEmail: true,
                                isSms: true,
                                isFax: true,
                                product: product,
                              }
                            "></ng-container>
                        }
                      </td>

                      <td>{{ product['area'] }}</td>
                      <td>
                        <ng-container
                          *ngTemplateOutlet="
                            productOutOfSeason;
                            context: { $implicit: product }
                          "></ng-container>
                      </td>
                      <td>
                        <ng-container
                          *ngTemplateOutlet="
                            productDates;
                            context: { $implicit: product }
                          "></ng-container>
                      </td>
                    </tr>
                  }
                </table>
              </mat-expansion-panel>
            }
          }

          @for (productType of ['egwsummer']; track $index) {
            @if (productListValue[productType].length > 0) {
              <mat-expansion-panel
                (expandedChange)="onExpandedChanged('delivery')">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    @if (
                      'delivery'
                        | hasUserProductType
                          : productType
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    ) {
                      <span>
                        <ng-container
                          *ngTemplateOutlet="greenCheckIcon"></ng-container>
                      </span>
                    } @else {
                      <span>
                        <ng-container
                          *ngTemplateOutlet="redTimesIcon"></ng-container>
                      </span>
                    }
                    &nbsp;
                    {{ 'SAISON.' + egpTypesValue[productType] | translate }}
                  </mat-panel-title>
                  <mat-panel-description>
                    {{
                      'delivery'
                        | countUserProducts
                          : 'egwsummer'
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    }}
                    /
                    {{ productListValue.egwsummer.length }}
                    {{ 'PRODUCT.USERADMIN.WARNPLACES' | translate }}
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <table class="product-detail-table">
                  <tr>
                    <th colspan="4">
                      {{ 'PRODUCT.USERADMIN.QUIET_TIMES' | translate }}
                    </th>
                  </tr>
                  <tr>
                    <td colspan="4">
                      <mat-checkbox
                        #pause
                        formControlName="egwsummer_isSmsPause"
                        (change)="
                          onSmsPauseChange($event.checked, 'egwsummer')
                        "></mat-checkbox>
                      {{ 'PRODUCT.USERADMIN.ACTIVATE_NIGHT_MODE' | translate }}
                    </td>
                  </tr>
                  @if (pause.checked) {
                    <tr>
                      <td>
                        <fa-icon [icon]="['far', 'bed']" size="2x"></fa-icon>
                      </td>
                      <td>
                        <mat-form-field style="width: 120px">
                          <mat-label>{{
                            'PRODUCT.USERADMIN.FROM' | translate
                          }}</mat-label>
                          <input
                            matInput
                            formControlName="egwsummer_smsPauseStart"
                            type="number"
                            style="width: 100px"
                            (change)="
                              onChangePause('egwsummer', 'start', $event)
                            " />
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field style="width: 120px">
                          <mat-label>{{
                            'PRODUCT.USERADMIN.TO' | translate
                          }}</mat-label>
                          <input
                            matInput
                            formControlName="egwsummer_smsPauseEnd"
                            type="number"
                            style="width: 100px"
                            (change)="
                              onChangePause('egwsummer', 'end', $event)
                            " />
                        </mat-form-field>
                      </td>
                      <td>
                        {{ 'PRODUCT.USERADMIN.NO_SUMMER_WARNINGS' | translate }}
                      </td>
                    </tr>
                  }
                </table>
                <br />

                <table class="product-detail-table" width="100%">
                  <tr>
                    <th align="center">
                      {{ 'PRODUCT.USERADMIN.DELIVERY.TITLE' | translate }}
                    </th>
                    <th>{{ 'PRODUCT.USERADMIN.DELIVERY.TO' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.WARNPLACE' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.WARNTYPES' | translate }}</th>
                    @if (
                      false && (productListValue.egwsummer | hasThresholds)
                    ) {
                      <th class="thresholds-column">
                        {{ 'PRODUCT.USERADMIN.THRESHOLDS_HEADER' | translate }}
                      </th>
                    }
                    <th class="active-column">
                      {{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}
                    </th>
                    <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                  </tr>
                  @for (
                    product of productListValue.egwsummer;
                    track $index;
                    let i = $index
                  ) {
                    <tr>
                      <td align="center">
                        <mat-checkbox
                          #check
                          [checked]="
                            'delivery'
                              | hasUserProduct
                                : areAllProductsSelectedValue
                                : userServiceUserDataValue
                                : product['id']
                          "
                          (change)="
                            onDeliveryChange(
                              $event,
                              product,
                              product['formControlName']
                            )
                          "></mat-checkbox>
                      </td>
                      <td>
                        @if (
                          check.checked &&
                          ('delivery'
                            | hasUserProduct
                              : areAllProductsSelectedValue
                              : userServiceUserDataValue
                              : product['id'])
                        ) {
                          <ng-container
                            *ngTemplateOutlet="
                              deliverTargets;
                              context: {
                                isEmail: true,
                                isSms: true,
                                isFax: true,
                                product: product,
                              }
                            "></ng-container>
                        }
                      </td>
                      <td>{{ product['area'] }}</td>
                      <td>
                        <div>
                          @if (product['productData']['info']) {
                            <div class="warning-type-row">
                              {{ 'PRODUCT.WARNING.TYPE.VORAB' | translate }}
                              (E-Mail)
                            </div>
                          }

                          @if (product['productData']['nowcast']) {
                            <div class="warning-type-row">
                              {{ 'METPARA_MEDIUM.THUNDERSTORM' | translate }}
                            </div>
                          }

                          @if (product['productData']['heavyRainWarning']) {
                            <div class="warning-type-row">
                              {{ 'METPARA_SHORT.HEAVY_RAIN' | translate }}
                            </div>
                          }

                          @if (product['productData']['precipitationWarning']) {
                            <div class="warning-type-row">
                              {{
                                'PRODUCT.EGP-SUMMER.RISKBOX.DRAIN' | translate
                              }}
                            </div>
                          }

                          @if (product['productData']['windWarning']) {
                            <div class="warning-type-row">
                              {{
                                'PRODUCT.EGP-SUMMER.RISKBOX.STORM' | translate
                              }}
                            </div>
                          }
                        </div>
                      </td>
                      @if (
                        false && (productListValue.egwsummer | hasThresholds)
                      ) {
                        <td>
                          <div class="thresholds-column">
                            @if (product['productData']['info']) {
                              <div class="thresholds-row">
                                <mat-checkbox
                                  [formControlName]="
                                    product['infoFormControlName']
                                  ">
                                </mat-checkbox>
                              </div>
                            }
                            @let egwsummerThresholdOptionsValue =
                              egwsummerThresholdOptions();

                            @if (product['productData']['nowcast']) {
                              <div class="thresholds-row">
                                @if (check.checked) {
                                  <mat-form-field
                                    class="small-select u-width-100">
                                    <mat-select
                                      panelWidth="500"
                                      [formControlName]="
                                        product['nowcastFormControlName']
                                      "
                                      [placeholder]="
                                        'PRODUCT.USERADMIN.NONE' | translate
                                      ">
                                      <mat-select-trigger>
                                        <span
                                          [matTooltip]="
                                            'PRODUCT.USERADMIN.THUNDERSTORM.' +
                                              formGroupDelivery.controls[
                                                product[
                                                  'nowcastFormControlName'
                                                ]
                                              ].value | translate
                                          "
                                          matTooltipPosition="left">
                                          {{
                                            'PRODUCT.USERADMIN.THUNDERSTORM.' +
                                              formGroupDelivery.controls[
                                                product[
                                                  'nowcastFormControlName'
                                                ]
                                              ].value | translate
                                          }}
                                        </span>
                                      </mat-select-trigger>
                                      <mat-option
                                        [value]="null"
                                        [matTooltip]="
                                          'PRODUCT.USERADMIN.NONE' | translate
                                        "
                                        matTooltipPosition="left">
                                        {{
                                          'PRODUCT.USERADMIN.NONE' | translate
                                        }}
                                      </mat-option>
                                      @for (
                                        option of egwsummerThresholdOptionsValue;
                                        track $index
                                      ) {
                                        <mat-option
                                          [value]="option"
                                          [matTooltip]="
                                            'PRODUCT.USERADMIN.THUNDERSTORM.' +
                                              option | translate
                                          "
                                          matTooltipPosition="left">
                                          {{
                                            'PRODUCT.USERADMIN.THUNDERSTORM.' +
                                              option | translate
                                          }}
                                        </mat-option>
                                      }
                                    </mat-select>
                                  </mat-form-field>
                                }
                              </div>
                            }

                            @if (product['productData']['heavyRainWarning']) {
                              <div class="thresholds-row">
                                @if (check.checked) {
                                  <mat-form-field
                                    class="small-select u-width-100">
                                    <mat-select
                                      panelWidth="500"
                                      [formControlName]="
                                        product[
                                          'heavyRainWarningFormControlName'
                                        ]
                                      "
                                      [placeholder]="
                                        'PRODUCT.USERADMIN.NONE' | translate
                                      ">
                                      <mat-select-trigger>
                                        <span
                                          [matTooltip]="
                                            'PRODUCT.USERADMIN.HEAVY_RAIN.' +
                                              formGroupDelivery.controls[
                                                product[
                                                  'heavyRainWarningFormControlName'
                                                ]
                                              ].value | translate
                                          "
                                          matTooltipPosition="left">
                                          {{
                                            'PRODUCT.USERADMIN.HEAVY_RAIN.' +
                                              formGroupDelivery.controls[
                                                product[
                                                  'heavyRainWarningFormControlName'
                                                ]
                                              ].value | translate
                                          }}
                                        </span>
                                      </mat-select-trigger>
                                      <mat-option
                                        [value]="null"
                                        [matTooltip]="
                                          'PRODUCT.USERADMIN.NONE' | translate
                                        "
                                        matTooltipPosition="left">
                                        {{
                                          'PRODUCT.USERADMIN.NONE' | translate
                                        }}
                                      </mat-option>
                                      @for (
                                        option of egwsummerThresholdOptionsValue;
                                        track $index
                                      ) {
                                        <mat-option
                                          [value]="option"
                                          [matTooltip]="
                                            'PRODUCT.USERADMIN.HEAVY_RAIN.' +
                                              option | translate
                                          "
                                          matTooltipPosition="left">
                                          {{
                                            'PRODUCT.USERADMIN.HEAVY_RAIN.' +
                                              option | translate
                                          }}
                                        </mat-option>
                                      }
                                    </mat-select>
                                  </mat-form-field>
                                }
                              </div>
                            }

                            @if (
                              product['productData']['precipitationWarning']
                            ) {
                              <div class="thresholds-row">
                                @if (check.checked) {
                                  <mat-form-field
                                    class="small-select u-width-100">
                                    <mat-select
                                      panelWidth="500"
                                      [formControlName]="
                                        product[
                                          'precipitationWarningFormControlName'
                                        ]
                                      "
                                      [placeholder]="
                                        'PRODUCT.USERADMIN.NONE' | translate
                                      ">
                                      <mat-select-trigger>
                                        <span
                                          [matTooltip]="
                                            'PRODUCT.USERADMIN.DRAIN.' +
                                              formGroupDelivery.controls[
                                                product[
                                                  'precipitationWarningFormControlName'
                                                ]
                                              ].value | translate
                                          "
                                          matTooltipPosition="left">
                                          {{
                                            'PRODUCT.USERADMIN.DRAIN.' +
                                              formGroupDelivery.controls[
                                                product[
                                                  'precipitationWarningFormControlName'
                                                ]
                                              ].value | translate
                                          }}
                                        </span>
                                      </mat-select-trigger>
                                      <mat-option
                                        [value]="null"
                                        [matTooltip]="
                                          'PRODUCT.USERADMIN.NONE' | translate
                                        "
                                        matTooltipPosition="left">
                                        {{
                                          'PRODUCT.USERADMIN.NONE' | translate
                                        }}
                                      </mat-option>
                                      @for (
                                        option of egwsummerThresholdOptionsValue;
                                        track $index
                                      ) {
                                        <mat-option
                                          [value]="option"
                                          [matTooltip]="
                                            'PRODUCT.USERADMIN.DRAIN.' + option
                                              | translate
                                          "
                                          matTooltipPosition="left">
                                          {{
                                            'PRODUCT.USERADMIN.DRAIN.' + option
                                              | translate
                                          }}
                                        </mat-option>
                                      }
                                    </mat-select>
                                  </mat-form-field>
                                }
                              </div>
                            }

                            @if (product['productData']['windWarning']) {
                              <div class="thresholds-row">
                                @if (check.checked) {
                                  <mat-form-field
                                    class="small-select u-width-100">
                                    <mat-select
                                      panelWidth="500"
                                      [formControlName]="
                                        product['windWarningFormControlName']
                                      "
                                      [placeholder]="
                                        'PRODUCT.USERADMIN.NONE' | translate
                                      ">
                                      <mat-select-trigger>
                                        <span
                                          [matTooltip]="
                                            'PRODUCT.USERADMIN.STORM.' +
                                              formGroupDelivery.controls[
                                                product[
                                                  'windWarningFormControlName'
                                                ]
                                              ].value | translate
                                          "
                                          matTooltipPosition="left">
                                          {{
                                            'PRODUCT.USERADMIN.STORM.' +
                                              formGroupDelivery.controls[
                                                product[
                                                  'windWarningFormControlName'
                                                ]
                                              ].value | translate
                                          }}
                                        </span>
                                      </mat-select-trigger>
                                      <mat-option
                                        [value]="null"
                                        [matTooltip]="
                                          'PRODUCT.USERADMIN.NONE' | translate
                                        "
                                        matTooltipPosition="left">
                                        {{
                                          'PRODUCT.USERADMIN.NONE' | translate
                                        }}
                                      </mat-option>
                                      @for (
                                        option of egwsummerThresholdOptionsValue;
                                        track $index
                                      ) {
                                        <mat-option
                                          [value]="option"
                                          [matTooltip]="
                                            'PRODUCT.USERADMIN.STORM.' + option
                                              | translate
                                          "
                                          matTooltipPosition="left">
                                          {{
                                            'PRODUCT.USERADMIN.STORM.' + option
                                              | translate
                                          }}
                                        </mat-option>
                                      }
                                    </mat-select>
                                  </mat-form-field>
                                }
                              </div>
                            }
                          </div>
                        </td>
                      }
                      <td>
                        <ng-container
                          *ngTemplateOutlet="
                            productOutOfSeason;
                            context: { $implicit: product }
                          "></ng-container>
                      </td>
                      <td>
                        <ng-container
                          *ngTemplateOutlet="
                            productDates;
                            context: { $implicit: product }
                          "></ng-container>
                      </td>
                    </tr>
                  }
                </table>
              </mat-expansion-panel>
            }
          }
        </mat-accordion>
        @if (productListValue.egwgma.length > 0) {
          <!--egwgma-->
          <div mat-subheader>
            <fa-icon [icon]="['far', 'bell-exclamation']" size="lg"></fa-icon>
            &nbsp; {{ 'PRODUCT.GMAALARM.TITLE' | translate }}
          </div>
        }
        <mat-accordion
          #accordionEgwGmaDelivery="matAccordion"
          multi
          class="accordion-headers-align">
          @for (productType of ['egwgma']; track $index) {
            @if (productListValue[productType].length > 0) {
              <mat-expansion-panel
                (expandedChange)="onExpandedChanged('delivery')">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    @if (
                      'delivery'
                        | hasUserProductType
                          : productType
                          : productListValue
                          : areAllProductsSelectedValue
                          : userServiceUserDataValue
                    ) {
                      <span>
                        <ng-container
                          *ngTemplateOutlet="greenCheckIcon"></ng-container>
                      </span>
                    } @else {
                      <span>
                        <ng-container
                          *ngTemplateOutlet="redTimesIcon"></ng-container>
                      </span>
                    }
                    &nbsp;
                    {{ 'PRODUCT.GMAALARM.TITLE' | translate }}
                  </mat-panel-title>
                  <mat-panel-description>
                    {{
                      'delivery'
                        | countUserProductStations
                          : areAllProductsSelectedValue
                          : 'egwgma'
                          : {
                              productType: productType,
                            }
                          : productListValue
                          : userServiceUserDataValue
                    }}
                    / {{ productListValue.egwgma.length }}
                    {{ 'PRODUCT.USERADMIN.STATIONS' | translate }}
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <table class="product-detail-table">
                  <tr>
                    <th colspan="4">
                      {{ 'PRODUCT.USERADMIN.QUIET_TIMES' | translate }}
                    </th>
                  </tr>
                  <tr>
                    <td colspan="4">
                      <mat-checkbox
                        #pause
                        formControlName="egwgma_isSmsPause"
                        (change)="
                          onSmsPauseChange($event.checked, 'egwgma')
                        "></mat-checkbox>
                      {{ 'PRODUCT.USERADMIN.ACTIVATE_NIGHT_MODE' | translate }}
                    </td>
                  </tr>
                  @if (pause.checked) {
                    <tr>
                      <td>
                        <fa-icon [icon]="['far', 'bed']" size="2x"></fa-icon>
                      </td>
                      <td>
                        <mat-form-field style="width: 120px">
                          <mat-label>{{
                            'PRODUCT.USERADMIN.FROM' | translate
                          }}</mat-label>
                          <input
                            matInput
                            formControlName="egwgma_smsPauseStart"
                            type="number"
                            style="width: 100px"
                            (change)="
                              onChangePause('egwgma', 'start', $event)
                            " />
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field style="width: 120px">
                          <mat-label>{{
                            'PRODUCT.USERADMIN.TO' | translate
                          }}</mat-label>
                          <input
                            matInput
                            formControlName="egwgma_smsPauseEnd"
                            type="number"
                            style="width: 100px"
                            (change)="onChangePause('egwgma', 'end', $event)" />
                        </mat-form-field>
                      </td>
                      <td>
                        {{ 'PRODUCT.USERADMIN.NO_GMA_ALARMS' | translate }}
                      </td>
                    </tr>
                  }
                </table>
                <br />
                <table class="product-detail-table" width="100%">
                  <tr>
                    <th align="center">
                      {{ 'PRODUCT.USERADMIN.DELIVERY.TITLE' | translate }}
                    </th>
                    <th>{{ 'PRODUCT.USERADMIN.DELIVERY.TO' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.STATION' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                    <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                  </tr>
                  @for (
                    product of productListValue.egwgma;
                    track $index;
                    let i = $index
                  ) {
                    <tr>
                      <td align="center">
                        <mat-checkbox
                          #check
                          [checked]="
                            userServiceUserDataValue
                              | hasUserStation
                                : product
                                : 'delivery'
                                : areAllProductsSelectedValue
                          "
                          (change)="
                            onDeliveryChange(
                              $event,
                              product,
                              product['formControlName']
                            )
                          "></mat-checkbox>
                      </td>
                      <td>
                        @if (
                          check.checked &&
                          ('delivery'
                            | hasUserProduct
                              : areAllProductsSelectedValue
                              : userServiceUserDataValue
                              : product['id'])
                        ) {
                          <ng-container
                            *ngTemplateOutlet="
                              deliverTargets;
                              context: {
                                isEmail: true,
                                isSms: true,
                                isFax: false,
                                product: product,
                              }
                            "></ng-container>
                        }
                      </td>

                      <td>{{ product['station']['overwriteStationName'] }}</td>
                      <td>
                        <ng-container
                          *ngTemplateOutlet="
                            productOutOfSeason;
                            context: { $implicit: product }
                          "></ng-container>
                      </td>
                      <td>
                        <ng-container
                          *ngTemplateOutlet="
                            productDates;
                            context: { $implicit: product }
                          "></ng-container>
                      </td>
                    </tr>
                  }
                </table>
              </mat-expansion-panel>
            }
          }
        </mat-accordion>
      </mat-list>
    </mat-card>
  }

  <div class="button-row">
    <button
      mat-raised-button
      class="btn-app-cancel"
      type="button"
      (click)="onCancel()">
      {{ 'PRODUCT.USERADMIN.CANCEL' | translate }}
    </button>
    &nbsp;
    <button
      mat-raised-button
      class="btn-app-back"
      type="button"
      matStepperPrevious>
      {{ 'PRODUCT.USERADMIN.BACK' | translate }}
    </button>
    &nbsp;
    <button mat-raised-button class="btn-app-next" matStepperNext>
      {{ 'PRODUCT.USERADMIN.NEXT' | translate }}
    </button>
    &nbsp;
    @if (!newUser()) {
      <button
        [disabled]="isSaving() || userService.loadingUserList()"
        mat-raised-button
        class="btn-app-save"
        (click)="onSummarizeUser()">
        {{ 'PRODUCT.USERADMIN.SAVE' | translate }}
      </button>
    }
  </div>

  <ng-template
    #deliverTargets
    let-product="product"
    let-isSms="isSms"
    let-isEmail="isEmail"
    let-isFax="isFax">
    <mat-form-field style="width: 100%; min-width: 300px" required>
      <mat-label>{{
        'PRODUCT.USERADMIN.DELIVERY.' +
          ((addressSelect | isNil) ||
          (addressSelect.value | isNil) ||
          addressSelect.value.length === 0
            ? 'TARGETSSELECT'
            : 'TARGETS') | translate
      }}</mat-label>
      <mat-select
        multiple
        [formControlName]="product['formControlName']"
        #addressSelect
        required>
        @if (isSms) {
          @if ((deliveryTargetsValue?.sms ?? []).length > 0) {
            <mat-optgroup label="SMS">
              <ng-container>
                @for (address of deliveryTargetsValue.sms; track $index) {
                  @let phone = address | verifyPhoneNumber;
                  <mat-option [value]="'sms' + phone">
                    +{{ phone }}
                  </mat-option>
                }
              </ng-container>
            </mat-optgroup>
          }
        }
        @if (isEmail) {
          @if ((deliveryTargetsValue?.email ?? []).length > 0) {
            <mat-optgroup label="E-Mail">
              @for (address of deliveryTargetsValue.email; track $index) {
                <mat-option [value]="'email' + address">{{
                  address
                }}</mat-option>
              }
            </mat-optgroup>
          }
        }
        @if (isFax) {
          @if ((deliveryTargetsValue?.fax ?? []).length > 0) {
            <mat-optgroup label="Fax">
              <ng-container>
                @for (address of deliveryTargetsValue.fax; track $index) {
                  @let phone = address | verifyPhoneNumber;
                  <mat-option [value]="'fax' + phone">
                    +{{ phone }}
                  </mat-option>
                }
              </ng-container>
            </mat-optgroup>
          }
        }
      </mat-select>
    </mat-form-field>
  </ng-template>
</form>

<ng-template #greenCheckIcon>
  <fa-icon [icon]="['far', 'check']" style="color: green"></fa-icon>
</ng-template>

<ng-template #redTimesIcon>
  <fa-icon [icon]="['far', 'times']" style="color: red"></fa-icon>
</ng-template>

<ng-template #productOutOfSeason let-product>
  @if (product['outOfSeason']) {
    <ng-container *ngTemplateOutlet="redTimesIcon"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="greenCheckIcon"></ng-container>
  }
</ng-template>

<ng-template #productDates let-product>
  {{ product['productData']['saison']['start']['day'] }}
  .{{ product['productData']['saison']['start']['month'] }}. -
  {{ product['productData']['saison']['end']['day'] }}
  .{{ product['productData']['saison']['end']['month'] }}.
</ng-template>
